import CityPageTemplate from "../city-template/CityPageTemplate";
import { nampaConfig } from "./data";

export default function NampaPage() {
  return <CityPageTemplate config={nampaConfig} />;
}